import api from '../../api/api'

const auth = {
  state: {
    list:[]
  },

  mutations: {
    SET_AUTH_LIST(state, data) {
      state.list = data
    }
  },

  actions: {
    async getAuthList({ commit }) {
      let ret = await api.getAuthList()
      commit('SET_AUTH_LIST', ret.data.data)
      console.log('可用权限列表', ret)
    }
  }

};

export default auth


// WEBPACK FOOTER //
// ./src/store/modules/auth.js